/* eslint-disable @typescript-eslint/ban-ts-ignore */
const wrapper = (content: string, footer: string) => `
  <div style='background-color:#eeeeee; height:100%;'>
    <div style="border-top:5px solid #1F5DEA; background:white;background-color:white;margin:0px auto;max-width:600px;">
    <div style='padding:0 41px;'>
      ${content}
    </div>
    ${footer}
    </div>
  </div>

`;

const footer = `
<div style="background:white;background-color:white;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:white;background-color:white;width:100%;">
        <tbody>
          <tr>
            <td style="border-top:1px solid #E6E6E5;direction:ltr;font-size:0px;padding:41px;text-align:center;">
              <!--[if mso | IE]>
                  <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                
        <tr>
      
            <td
               class="" style="vertical-align:top;width:516px;"
            >
          <![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody><tr>
                    <td align="left" style="font-size:0px;padding:0;word-break:break-word;">
                      <div style="font-family:Arial;font-size:9px;line-height:1;text-align:left;color:#42526E;">
                        <p> We have been instructed by {{company_name}} to contact you to participate in a survey. </p>
                        <p> Our customer has informed us that we may contact you for the survey on his behalf. If you still feel that your data protection rights are affected, you can contact our data protection officer at any time by emailing <a href="mailto:support@deeptrue.com">support@deeptrue.com</a>. </p>
                        <p> We are a market research institute based in Switzerland. Information about us can be found at <a href="https://www.deeptrue.com/">www.deeptrue.com</a>. For more detailed information on data processing by deeptrue AG, please refer to our <a href="https://deeptrue.com/privacy-policy/">Privacy Policy</a>. </p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style="font-size:0px;padding:0;word-break:break-word;">
                      <div style="margin-top:16px;font-family:Arial;font-size:13px;line-height:1;text-align:left;color:#42526E;">Powered by <img style="width: 90px; display:inline-block; vertical-align:middle;" src="https://s3-eu-west-1.amazonaws.com/mail.deeptrue.com/assets/logo.png"></div>
                    </td>
                  </tr>
                </tbody></table>
              </div>
              <!--[if mso | IE]>
            </td>
          
        </tr>
      
                  </table>
                <![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    `;

const CtaButton = (text: string) =>
  `<a href="{{ survey_url }}" style="display:inline-block;background:#1F5DEA;color:white;font-family:Arial;font-size:13px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px;mso-padding-alt:0px;border-radius:20px;" target="_blank">
  ${text}
   </a>`;

// TODO check why Safari not support
//const ctaTextRegexp = /(?<=#CTA-START#\s*).*?(?=\s*#CTA-END#)/g;
export const ctaBlock = /(#CTA-START#\s*).*?(\s*#CTA-END#)/g;

export const generateContent = (content: string) => {
  // @ts-ignore
  const adaptedContent = content.replaceAll(ctaBlock, (e) => {
    const text = e.replace('#CTA-START#', '').replace('#CTA-END#', '');

    if (text) {
      return CtaButton(text);
    } else {
      return ctaBlock;
    }
  });

  const wholeDoc = wrapper(adaptedContent, footer);

  return wholeDoc;
};

export const generatePreview = (content: string, isDefault: boolean) => {
  if (isDefault) {
    const win = window.open('about:blank', '_blank');
    // @ts-ignore
    win.document.write(content);
    // @ts-ignore
    return win.focus();
  }

  // @ts-ignore
  const adaptedContent = content.replaceAll(ctaBlock, (e) => {
    const text = e.replace('#CTA-START#', '').replace('#CTA-END#', '');

    if (text) {
      return CtaButton(text);
    } else {
      return ctaBlock;
    }
  });

  const wholeDoc = wrapper(adaptedContent, footer);
  const win = window.open('about:blank', '_blank');
  // @ts-ignore
  win.document.write(wholeDoc);
  // @ts-ignore
  return win.focus();
};
